import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    allDiscountManagementData: []
}
const mutations = {
    SET_DISCOUNT_MANAGEMENT_DATA(state, data) {
        state.allDiscountManagementData = data
    }
}
const actions = {
    fetchDiscountManagementDatas({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/discount/get_discount_data_list')
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push(res.data.message);
                } else {
                    commit("SET_DISCOUNT_MANAGEMENT_DATA", res.data);
                }
            })
            .catch(error => console.log(error))
    },

    createDiscountCoupon({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/discount/create_discount_coupon', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteDiscountCoupon({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/discount/delete_discount_voucher', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    disableDiscountCoupon({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/discount/disable_discount_voucher', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchDiscountCouponsDatas({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/discount/view_discount_coupon/' + authData.account + '/' + authData.bunch)
                .then(response => {
                    loader.hide()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchDiscountCouponsUserDatas({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/discount/view_discount_coupon_users', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    sellCouponToSubZone({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/discount/sell_coupons', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    getDiscountConfigData({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/discount/discount_configuration_list')
                .then(response => {
                    loader.hide()
                    if (response.data.status == "redirect") {
                        router.push(response.data.message);
                    } else {
                        resolve(response.data);
                    }
                })
                .catch(error => console.log(error));
        });
    },
    saveDiscountCOnfig({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/discount/save_discount_configuration', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },

}
const getters = {
    discountManagementGetter: state => {
        return state.allDiscountManagementData
    },

}
export default {
    state,
    mutations,
    actions,
    getters
}

